module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig07_profile-deviation-tip-relief.e7113f50.png";